/* global BigInt */
import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther, parseUnits } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseUsdt = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.busd;

  const purchaseUsdt = useCallback(
    async (
      amount,
      postApiRes,
      id,
      balance,
      min,
      stakeIndex,
      index,
      insurancePer
    ) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      /* ------------------ Calculate USDT amount (6 decimals) ------------------ */
      let nd;
      if (index) {
        const percent = parseFloat(amount) * insurancePer;
        const value = parseFloat(amount) + percent;
        const fixed = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(fixed.toString(), 6);
      } else {
        const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(fixed.toString(), 6);
      }

      /* ------------------ Min value ------------------ */
      let minValue = min * 0.99;
      minValue = Math.round(parseFloat(minValue).toFixed(6) * 1e12) / 1e12;
      minValue = parseEther(minValue.toString());

      /* viem is strict about ABI types where web3.js was not:
         uint256 needs a bigint, uint8/uint32 need a number. */
      const args = [
        UsdtAdress, // address   token
        Number(postApiRes?.normalizationFactor), // uint8     referenceNormalizationFactor
        BigInt(postApiRes?.price), // uint256   referenceTokenPrice
        nd, // uint256   purchaseAmount
        minValue, // uint256   minAmountToken
        (stakeIndex ?? []).map((i) => BigInt(i)), // uint256[] indexes
        postApiRes?.agentsAddresses ?? [], // address[] leaders
        (postApiRes?.agentsPercentages ?? []).map((p) => BigInt(p)), // uint256[] percentages
        postApiRes.code, // string    code
        Number(id), // uint32    round
        BigInt(postApiRes.deadline), // uint256   deadline
        Number(postApiRes?.v), // uint8     v
        postApiRes?.r, // bytes32   r
        postApiRes?.s, // bytes32   s
      ];

      console.log(...args, "purchaseUsdt params");

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args,
        });

        console.log("PurchaseUsdt tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseUsdt confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseUsdt error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync, UsdtAdress]
  );

  return { purchaseUsdt };
};

export default usePurchaseUsdt;
